import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                'add-to-cart': 'addToCart'
            }
        }
    }

    init() {
        this.id = parseInt(this.getData('id'))
    }

    addToCart() {
        this.call('addItem', { id: this.id, quantity: 1 }, 'Cart')
    }
}
